import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { ToastrService } from 'ngx-toastr';

import { env } from '../../../environments/environment';
import { BuyResponseDto, ExchangeRatesDto, Currency, CartState} from '../../api';
import { GlitterOfferBaseDto } from '../../api/glitterOfferBaseDto';
import { PriceService } from '../../price.service';
import { PaymentService } from '../../payment.service';
import { Web3Service } from '../../web3.service';
import { ExchangeCartService } from '../exchange-cart.service';
import { ExchangeService } from '../exchange.service';
import { GlobalService } from '../../global.service';
import { defs, DigitsInfo } from '../../defs';
import { NGXLogger } from 'ngx-logger';
import { Money } from '../../bo/money';
import { PayPalConfig } from '../../bo/payPalConfig';

declare let paypal: any;

@Component({
	selector: 'narwhalia-exchange-cart',
	templateUrl: './exchange-cart.component.html',
	styleUrls: ['./exchange-cart.component.scss']
})
export class ExchangeCartComponent extends OnDestroyMixin implements OnInit, AfterViewInit {
	@Output() closePopup: EventEmitter<boolean>;
	cart: Map<GlitterOfferBaseDto, number>;
	sums: Money = new Money();
	digitsInfo: DigitsInfo = defs.digitsInfo;
	cartKeys: GlitterOfferBaseDto[];
	showCartPopup: boolean;
	rates: ExchangeRatesDto;
	paypalConfig: PayPalConfig;
	cartState: CartState;
	etherBalance: number;
	Currency = Currency

	private paypalMethods = {
		payment: () =>
			this.exchangeService.buyGlitterPackageCart('USD').then(res => {
				this.cartState = 'payment_in_progress';
				return res.payPalPaymentId;
			}),
		onAuthorize: (data, actions) =>
			this.paymentService
				.finalizePayPalPayment(data.paymentID, data.payerID)
				.then(() => {
					this.exchangeCartService.emptyCart();
					this.close();
				})
				.catch(() =>
					this.translateService
						.get('error.payment.pay_pal_rest_exception')
						.subscribe(translatedText => this.toastrService.error(translatedText))
				),
		onCancel: data =>
			this.paymentService
				.deletePayPalPayment(data.paymentID)
				.then(() => this.close())
				.catch(() =>
					this.translateService
						.get('error.payment.pay_pal_rest_exception')
						.subscribe(translatedText => this.toastrService.error(translatedText))
				)
	};

	@HostListener('document:click', ['$event'])
	clickedOutside(event) {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.close();
		}
	}

	constructor(
		private elementRef: ElementRef,
		private exchangeCartService: ExchangeCartService,
		private priceService: PriceService,
		private exchangeService: ExchangeService,
		private web3Service: Web3Service,
		private paymentService: PaymentService,
		private toastrService: ToastrService,
		private translateService: TranslateService,
		private globalService: GlobalService,
		private log: NGXLogger
	) {
		super();
		this.closePopup = new EventEmitter<boolean>();
		this.paypalConfig = {
			env: env.payPal.env,
			commit: env.payPal.commit,
			style: env.payPal.style,
			payment: this.paypalMethods.payment,
			onAuthorize: this.paypalMethods.onAuthorize,
			onCancel: this.paypalMethods.onCancel
		};
		this.priceService.priceUpdated$.pipe(untilComponentDestroyed(this)).subscribe(this.sumCart);
	}

	close = () => {
		this.closePopup.emit();
	};

	ngOnInit() {
		this.globalService.exchangeRates.pipe(untilComponentDestroyed(this)).subscribe((rates: ExchangeRatesDto) => {
			this.rates = rates;
			this.getCart();
		});
		this.getCartState();
		this.web3Service.getBalance()
			.then(etherBalance => {
				this.etherBalance = etherBalance;
			})
			// .catch(this.handleError);
	}

	sumCart = () => {
		let usd = 0;
		let gli = 0;
		for (const itemQuantity of this.cart) {
			const [item, quantity] = itemQuantity;
			usd += item.price.act * quantity;
			gli += item.amount * quantity;
		}
		this.sums = {	usd, gli,	eth: usd / this.rates.eth_usd	};
	};

	getCart = () => {
		// this.exchangeCartService.cart$.pipe(untilComponentDestroyed(this))
		this.exchangeCartService.getCart(this)
			.subscribe(cart => {
				this.cartKeys = Array.from(cart.keys());
				this.cart = cart;
				this.sumCart();
			});
	};

	getCartState = () => {
		this.exchangeCartService.cartState$
			.pipe(untilComponentDestroyed(this))
			.subscribe(cartState => (this.cartState = cartState));
/*		this.exchangeService.getExchangeCart()
			.pipe(untilComponentDestroyed(this))
			.subscribe(result => {
				this.exchangeCartService.initCart(result);
			});*/
	};

	buyGlitterPackage(currency: Currency) {
		this.web3Service
			.init()
			.then(() => this.exchangeService.buyGlitterPackageCart(currency))
			.then(this.web3Service.send)
			.then(this.close)
			.catch(err => {
				console.error(err);
				this.close();
			});
	}

	transfer = (response: BuyResponseDto) => {
		this.cartState = 'payment_in_progress';
		return this.web3Service.send(response)
	};

	ngAfterViewInit() {
		paypal.Button.render(this.paypalConfig, '#paypal-button');
	}
}